export default __webpack_public_path__ + "static/20-29309447848cb8b8e4e447c4c985372e.jpg";